import { categoriesStyles as styles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsCategories";
import { css } from "styled-components";

styles.title = {
    ...styles.title,
    css: css`
        border-width: 20px;
        padding-bottom: 10px;
    `,
};

styles.categoryImageItem = {
    width: 12,
    align: "middle",
    css: css`
        width: 100%;
        height: 160px;
        max-height: 160px;
        justify-content: center;

        a div {
            max-width: 160px;
            max-height: 160px;
            width: 160px;
            height: 160px;
        }

        img {
            max-height: 160px;
            max-width: 160px;
        }
    `,
};
